<template>
  <div class="mb-3">
    <template v-if="required">
      <label>¿Este archivo ya está firmado por el colaborador? *</label>
      <div class="mt-1">
        <label class="mr-3"><input type="radio" class="mr-1" :checked="value === true" @change="$emit('input', true)">Sí, la firma se ve en el archivo</label>
        <label><input type="radio" class="mr-1" :checked="value === false" @change="$emit('input', false)">No</label>
      </div>
    </template>
    <label v-else>
      <input type="checkbox" class="mr-1" :checked="value === true" @change="$emit('input', $event.target.checked)">
      Este archivo ya está firmado por el colaborador
    </label>
  </div>
</template>

<script>
// Pregunta obligatoria si el tipo exige la firma del colaborador: sin marcar no es lo mismo que "no está firmado".
export default {
  name: 'UploadSignedQuestion',
  props: {
    value: { type: Boolean, default: null },
    required: { type: Boolean, default: false },
    typeId: { type: [Number, String], default: null },
  },
  watch: {
    // Otro tipo, otra pregunta: la respuesta anterior no vale.
    typeId() { this.$emit('input', this.required ? null : false) },
  },
}
</script>
